import { Pipe, PipeTransform } from '@angular/core';
import { Vestiging } from '../models/vestiging.model';
import { Discipline } from '../models/discipline.model';

@Pipe({
  name: 'teamfilter',
  pure: false
})
export class TeamfilterPipe implements PipeTransform {

  transform(members: any[], filter: any): any {
    if (!members || !filter || Object.values(filter).length == 0) {
        return members;
    }
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    return members.filter(m =>
        this.stringMatch(m, filter) && this.locationMatch(m, filter) && this.disciplineMatch(m, filter));
    }

    stringMatch(m:any, filter:any):boolean {
      return !filter.text || filter.text == "" ||
      (m.voornaam.toLowerCase().indexOf(filter.text) != -1 || m.achternaam.toLowerCase().indexOf(filter.text) != -1);
    }

    locationMatch(m: any, filter: any): boolean {
      return !filter.praktijk || filter.praktijk == "" ||
      (filter.praktijk.toLowerCase() == "alle" || m.vestigingen.map((i: Vestiging)=>i.naam).indexOf(filter.praktijk) != -1);
    }

    disciplineMatch(m: any, filter: any): boolean {
      return !filter.discipline || filter.discipline == "" ||
      (filter.discipline.toLowerCase() == "alle" || m.disciplines.map((i: Discipline)=>i.naam).indexOf(filter.discipline) != -1);
    }
}
